module.exports = __webpack_public_path__ + "bootleggers_coffee_packaging_design_bag_pouch_design_front.jpg?22e955c248a58d3209a2a05c20aae201";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/bootleggers/bootleggers_coffee_packaging_design_bag_pouch_design_front.jpg
// module id = 41
// module chunks = 0